import { __decorate, __extends } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import QrcodeVue from 'qrcode.vue';
import html2canvas from 'html2canvas';
import { AvalonGTEvent } from '@/utils/Event';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.size = 120;
        _this.timer = null;
        _this.imageUrl = ''; //@ 2021/12/27 11:15 图片地址
        _this.useraParams = {
            imageUrl: '',
            bgUrl: '',
        };
        _this.url = '';
        return _this;
    }
    View.prototype.created = function () {
        AvalonGTEvent.eventHub.on(AvalonGTEvent.Global.GENERATE_PIC, this.generatePic);
    };
    //@ 2021/12/22 11:05 图片转换成base64
    View.prototype.generatePic = function (params) {
        var _this = this;
        var _a;
        var ratio = window.devicePixelRatio || 1;
        this.useraParams = params;
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var img = new Image();
        img.crossOrigin = 'Anonymous'; // 重点！设置image对象可跨域请求
        img.src = this.useraParams.imageUrl + '?timeStamp=' + new Date().getTime(); //解决缓存引起访问失败需要添加时间戳。。。。。问题的关键点
        img.onload = function () {
            canvas.height = img.height;
            canvas.width = img.width;
            ctx.drawImage(img, 0, 0);
            _this.imageUrl = canvas.toDataURL('image/png', 10);
        };
        //  2024-07-08 17:58:06：// 解决背景图片加载失败的问题
        var bgimg = new Image();
        bgimg.crossOrigin = 'Anonymous'; // 重点！设置image对象可跨域请求
        bgimg.src = this.awlGlobalConfig.getH5ImgUrl("invite/QrCode_" + (((_a = this.awlGlobalState.urlInitParams) === null || _a === void 0 ? void 0 : _a.package) || 'chuai') + ".png");
        bgimg.onload = function () {
            canvas.height = bgimg.height;
            canvas.width = bgimg.width;
            ctx.drawImage(bgimg, 0, 0);
            _this.useraParams.bgUrl = canvas.toDataURL('image/png', 10);
        };
        clearTimeout(this.timer);
        // this.test();
        this.timer = setTimeout(function () {
            _this.getHtml2canvas(params);
        }, 2000);
    };
    //@ 2021/12/22 16:38 生成图片
    View.prototype.getHtml2canvas = function (params) {
        var _this = this;
        var pic = document.querySelector('#pic');
        if (pic) {
            html2canvas(pic, {
                width: 330,
                height: 410,
                useCORS: true,
                scale: window.devicePixelRatio,
            }).then(function (canvas) {
                //@ 2021/12/23 11:26 TODO canvas背景设置透明
                var imageUrl = canvas.toDataURL('image/png', 10.0); // 将canvas转成base64图片格式
                params.imageBase64 = imageUrl;
                _this.url = imageUrl;
                _this.globalCommit('setting_image_base', imageUrl);
            });
        }
    };
    View.prototype.beforeDestroy = function () {
        clearTimeout(this.timer);
    };
    View.prototype.unmounted = function () {
        AvalonGTEvent.eventHub.off(AvalonGTEvent.Global.GENERATE_PIC, this.generatePic);
    };
    View = __decorate([
        Options({
            components: {
                QrcodeVue: QrcodeVue,
            },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
